<template>
    <div :id="data.id" @click="switchMenus(data)" class="card-item">
        <div class="d-flex">
            <Icon :icon="data.icon"/>
            <div data-name="details">
                <p>{{data.title}}</p>
                <p>{{data.count}}</p>
            </div>
        </div>
        <div data-name="new-res" class="d-flex justify-content-end">
            <p v-if="data.new > 0">
                +{{data.new}}
            </p>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import { useRouter } from '../../../core/hooks'
export default {
    name: 'CardItem',
    props: {
        data: Object
    },
    components: {
        Icon
    },
    setup(props, context) {
        const { router } = useRouter()
        const switchMenus = data => {
            context.root.$sendMixpanelEvent('Dashboard Overview Card Clicked', {
                'Card Name': data.title,
            })
            context.root.$ga.event('Dashboard', 'Overview Card Click', `
                CardName: ${data.title}
            `)
            router.push({name: data.location}).catch(()=> {})
        }

        return {
            switchMenus
        }
    }
}
</script>

<style lang="scss" scoped>
div.card-item {
    width: 360px;
    padding-left: 20px;
    padding-right: 16px;
    padding-top: 20px;
    padding-bottom: 16px;
    background: #ffffff;
    margin-right: 32px;
    border-radius: 8px;
    cursor: pointer;
    
    div[data-name="details"] {
        margin-left: 16px;
        p {
            color: #333333;
            margin-bottom: 0;
            &:first-child {
                font-size: 18px;
                line-height: 28px;
            }
            &:last-child {
                font-size: 27px;
                line-height: 35px;
                font-weight: bold;
            }
        }
    }
    div[data-name="new-res"] {
        p {
            font-size: 18px;
            line-height: 21px;
            color: #FA5C7C;
        }
    }
}
</style>